<template>
  <div class="promo-design-group">
    <div v-if="!isHorizontal" class="promo-all-buttons-inputs">
      <div class="promo-button-widalig">
        <h4>Width:</h4>
        <v-select
          v-model="actions.rf_settings_text_container_max_width"
          :items="buttonWidth"
          itemTitle="text"
          variant="outlined"
          required
          density="compact"
          hideDetails
          bgColor="#ffffff"
        ></v-select>
      </div>
      <div class="promo-button-widalig">
        <h4>Position:</h4>
        <v-select
          v-model="actions.rf_settings_bar_position"
          :items="buttonPosition"
          itemTitle="text"
          variant="outlined"
          required
          density="compact"
          hideDetails
          bgColor="#ffffff"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RfRetentionButtonsAlignment",
  props: ["actions", "model"],
  data() {
    return {
      buttonWidth: [
        {
          text: "Normal",
          value: "normal",
        },
        {
          text: "Full",
          value: "full",
        },
      ],
      buttonPosition: [
        {
          text: "Top",
          value: "top",
        },
        {
          text: "Bottom",
          value: "bottom",
        },
      ],
    };
  },
  computed: {
    isHorizontal() {
      return this.model.path_type === "horizontal";
    },
  },
  watch: {},
};
</script>
